import React, { useState } from "react";
import { Box, Typography, Stack, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { StatePageContainer } from "../../components/ui-elements/pageUITransition";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import {
  OnboardVerifyAccountData,
  OnboardVerifyAccountDummyData,
} from "../../interface/onboard";

import {
  OnboardingMainModal,
  OnboardingSkipModal,
} from "../../components/onboarding/modal";
import { useQuery } from "@tanstack/react-query";
import { apiGetOnboardDetails } from "../../api/authentication";
import { useNotificationService } from "../../hooks/notification";
import { AccountOnboardingContent } from "../../components/onboarding/account-content";

const OnboardingAccount: React.FC = () => {
  
  const navigate = useNavigate();
  const { showNotification } = useNotificationService();

  const [user_data, setUser_data] = useState<OnboardVerifyAccountData>(
    OnboardVerifyAccountDummyData
  );

  const [modal_state, setModal_state] = useState(false);
  const [modal_skip, setModal_skip] = useState(false);

  const { data, isLoading } = useQuery({
    queryKey: ["userDetails"],
    queryFn: async () => {
      const result = await apiGetOnboardDetails();
      if (result.status === "error" && "details" in result) {
        showNotification(result.details, "error");
        return OnboardVerifyAccountDummyData;
      }
      if (result?.status === 200) {
        setUser_data(result.data);
      }
      return result?.data || OnboardVerifyAccountDummyData;
    },
  });

  const handle_back = () => navigate(-1);
  const handle_modal = () => {
    setModal_state(!modal_state);
  };
  const handle_modal_skip = () => {
    setModal_skip(!modal_skip);
  };

  return (
    <>
      <OnboardingMainModal open={modal_state} modal_handler={handle_modal} />
      <OnboardingSkipModal
        open={modal_skip}
        modal_handler={handle_modal_skip}
      />
      <Box
        sx={{
          height: "100vh",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            width: "94%",
            mx: "auto",
            mt: 6,
          }}
        >
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            sx={{
              width: "100%",
            }}
          >
            <Button
              startIcon={<KeyboardArrowLeftIcon />}
              onClick={handle_back}
              sx={{
                color: "#7991A4",
              }}
            >
              Back
            </Button>

            <img
              alt=""
              src="/assets/icons/logo-green.svg"
              width={100}
              height={35}
            />
            <Button
              sx={{
                color: "#7991A4",
              }}
            ></Button>
          </Stack>
          <Stack sx={{ my: 2 }}>
            <Typography
              variant="body1"
              sx={{
                color: "#92A5B5",
                textAlign: "center",
                letterSpacing: "3px",
                fontWeight: 500,
              }}
            >
              2/2
            </Typography>
          </Stack>
          <>
          
            <StatePageContainer id="page2">
              <AccountOnboardingContent user_data={user_data} />
            </StatePageContainer>
          
          </>
        </Box>
      </Box>
    </>
  );
};

export default OnboardingAccount;
